import React from "react";
import Fab from "@mui/material/Fab";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Fade from "@mui/material/Fade";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import LanguageIcon from "@mui/icons-material/Language";
import Link from "next/link";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: any;
}

const ScrollTowebprint = (props: any) => {
  return (
    <Box sx={{ zIndex: 999 }} className="top-w">
      <Link href="https://pricesimulator.itp.co.th/" target="_blank">
        <div className="icon-web_printing">
          <div className="n-ppost"></div>
          <div className="n-ppost-name">Get Quote</div>
        </div>
      </Link>
    </Box>
  );
};

export default ScrollTowebprint;
